var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDropdownArrow = function SvgDropdownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.635 10a1 1 0 0 0-.768 1.64l2.865 3.438a1 1 0 0 0 1.536 0l2.865-3.438a1 1 0 0 0-.768-1.64h-5.73Z",
    fill: "#161643"
  })));
};

export default SvgDropdownArrow;